import api from './api';

export async function fetchDashboardStatsData() {
  const response = await api.get('/get-dashboard-stats-data');
  return response?.data?.dataset?.data || {};
}
